import { render, staticRenderFns } from "./invoice__list.vue?vue&type=template&id=0d6b6060"
import script from "./invoice__list.vue?vue&type=script&lang=js"
export * from "./invoice__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports